/**
 * Logique de navigation du carrousel d'accueil, extraite du composant pour être
 * testable sans jsdom (les pointer events y sont peu fiables).
 */

/** Distance horizontale minimale (px) pour qu'un glissé change de diapositive. */
export const SWIPE_THRESHOLD_PX = 50;

/** Mouvement franc (px) à partir duquel l'axe du geste est verrouillé (horizontal ou vertical). */
export const AXIS_LOCK_PX = 6;

export function clampIndex(index: number, count: number): number {
  if (count <= 0) return 0;
  return Math.min(Math.max(index, 0), count - 1);
}

export function nextIndex(index: number, count: number): number {
  return clampIndex(index + 1, count);
}

export function prevIndex(index: number): number {
  return Math.max(index - 1, 0);
}

/** Décalage de la piste pour l'index courant : `translateX(offset%)`. */
export function slideOffsetPercent(index: number): number {
  return -index * 100;
}

/**
 * Index cible après un glissé horizontal de `deltaX` pixels.
 * `deltaX` négatif = doigt vers la gauche = diapositive suivante.
 * Sous le seuil, l'index ne bouge pas (retour élastique).
 */
export function resolveSwipe(
  deltaX: number,
  index: number,
  count: number,
  threshold: number = SWIPE_THRESHOLD_PX,
): number {
  if (deltaX <= -threshold) return nextIndex(index, count);
  if (deltaX >= threshold) return prevIndex(index);
  return clampIndex(index, count);
}
